import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";

const localeNamespace = "settings.workflows.templates.categories";

interface WorkflowTemplateCategoryPillProps {
  category?: string;
}

export const WorkflowTemplateCategoryPill = ({
  category,
}: WorkflowTemplateCategoryPillProps) => {
  if (!category) {
    return null;
  }

  return (
    <span className="border-primary text-dark inline-flex items-center rounded-full border px-2 py-1">
      <Typography.LabelXxs weight="medium" textTransform="capitalize">
        {t([localeNamespace, category])}
      </Typography.LabelXxs>
    </span>
  );
};
